import {DirectusTranslation} from '@frontend/directus';
import {ProviderDocumentVisibility} from '@frontend/shared-api';

export const FINAL_DOCUMENT_STATUS_UUID = 'f9933b34-afc8-490e-a502-283e858e685a';

export interface DocumentUploadCardItem {
  id: number;
  fileName: string;
  originalFileName?: string;
  fileSizeKb?: number;
  createdAt?: string;
  version?: string;
  statusUuid?: string;
  visibility?: ProviderDocumentVisibility;
  previewable?: boolean;
}

export interface DocumentUploadCardRow {
  document: DocumentUploadCardItem;
  statusTranslations: DirectusTranslation[];
  hasStatus: boolean;
  previewable: boolean;
}

export interface DocumentUploadCardRowContext {
  $implicit: DocumentUploadCardItem;
}

export interface DocumentUploadDialogData {
  file?: File;
  isEdit?: boolean;
  originalFilename?: string;
  fileName?: string;
  version?: string;
  documentStatusUuid?: string;
  visibility?: ProviderDocumentVisibility;
  showStatus?: boolean;
  isFileNameReadonly?: boolean;
  defaultVersion?: string;
}

export interface DocumentUploadDialogResult {
  fileName: string;
  version: string;
  statusUuid: string;
  visibility: ProviderDocumentVisibility;
}

export interface DocumentUploadCardUpload extends DocumentUploadDialogResult {
  file: File;
}

export interface DocumentUploadCardEdit extends DocumentUploadDialogResult {
  id: number;
}
